import Vue from 'vue'
import { configure, extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, min, max, confirmed, alpha, alpha_spaces, regex, required_if, min_value, max_value, is, is_not, numeric, ext, size } from 'vee-validate/dist/rules';

extend('required', required)
extend('email', email)
extend('min', min)
extend('max', max)
extend('confirmed', confirmed)
extend('alpha', alpha)
extend('alpha_spaces', alpha_spaces)
extend('regex', regex)
extend('required_if', required_if)
extend('min_value', min_value )
extend('max_value', max_value )
extend('is', is )
extend('is_not', is_not )
extend('numeric', numeric )
extend('ext', ext )
extend('size', size )

extend('confirm', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});

extend('text_lines_height', {
  params: ['max_height', 'height', 'lines'],
  validate(value, { max_height, height }) {
    return height <= max_height;
  },
  message: 'The {_field_} field must not exceed {lines} lines'
});

const config = {
    classes: {
        valid: 'field-valid is-valid',
        invalid: 'field-invalid is-invalid'
    }
};

configure(config);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
